import style from "./style.scss";
import { mergeClasses } from "../../helpers";

const Down = ({ open = false, class: className = null }) => (
  <span class={mergeClasses([className, style.down, open ? style.open : null])}>
    <span class={style.wrapper}>
      <span class={style.line} />
      <span class={style.line} />
    </span>
  </span>
);

export default Down;
